import { CaptionStyles, CaptionLineConfig, HighlightTypeEnum } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const marker: Partial<CaptionStyles> = {
  theme_preset: 'marker',
  pageStyle: {
    color: '#ffffff'
  },
  wordStyle: {
    active: {
      color: '#ffffff'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Box,
    highlightBoxStyle: {
      background: '#00ff04',
      borderRadius: '8px',
      inset: '-6px -12px'
    }
  },
  letterStyle: undefined,
  font_location: getFontFullPath('Anton-Regular.ttf'),
  caps: true,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.Spring
  }
};

export default marker;
